module.exports = __webpack_public_path__ + "img/open-eye.d7ff81d2.svg";